module.exports = __webpack_public_path__ + "static/media/bg_bacteria_red.b9825e93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_bacteria_red.jpg
// module id = 58
// module chunks = 0